import { DOCS_URL } from "../../../config/constants.js";
import ServicePageSection from "./ServicePageSection.svelte";

export default {
    component: ServicePageSection,
    name: "Service Page Section",
    description: "Service page rich text section that can appear in the in-page navigation",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-servicepagesection--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/section.svg",
    models: ["service-page"],
    inputs: [
        {
            friendlyName: "Navigation Label",
            name: "navLabel",
            type: "string",
            helperText: "Label used in the service page in-page navigation.",
        },
        {
            friendlyName: "Anchor ID",
            name: "anchorId",
            type: "string",
            helperText: "Optional stable anchor. Use lowercase words separated by hyphens.",
        },
        {
            friendlyName: "Heading",
            name: "heading",
            type: "string",
        },
        {
            friendlyName: "Heading Level",
            name: "headingLevel",
            type: "text",
            enum: ["h2", "h3", "h4", "h5", "h6"],
            defaultValue: "h3",
        },
        {
            friendlyName: "Content",
            name: "richText",
            type: "richText",
            required: true,
        },
    ],
};
